/**
 * Enrollee Section State Manager 
 * STATE MANAGER HANDLERS
 * mStateManager + TabName+ '_EVENT()'
 */ 
// STATE MANAGER HANDLERS TAB ENROLLEES
function mStateManagerEnrollees_Init(aPrevious, aCurrent) {
    "use strict";
    mStateManager.refreshEMAGetStatus = true;
    var lLayout = mStateManager.Tab() + '.Layout.htm';
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        //enrolleesTagDataListConverter();
        enrolleesDataListConverter();
        enrolleesStationListConverter();
        mEnrolleesControls.CardViewTimer = new TimerManager(500);
        mCache.bind('EnrolleeLastContactupdated', EnrolleeLastContact_Updated);
        mCache.bind('CurrentDeviceAssignmentsupdated', enrolleesDataItem_Updated);
        mCache.bind('EnrolleeEventSummaryupdated', enrolleesDataItem_Updated);
        mCache.bind('Enrolleesupdated', enrolleesDataItem_Updated);
        mCache.bind('EnrolleeLastContactupdated', enrolleesDataItem_Updated);
        mCache.bind('DeviceClusterEnrolleeupdated', enrolleesDataItem_Updated);
        populateElement('uMasterContentHolder', lLayout, mStateManagerEnrollees_OnComplete);
    }


}
// LOAD COMPLETE
function mStateManagerEnrollees_OnComplete() {
    "use strict";
   
    applyUserPermissions([1, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 32, 46, 47, 48, 49, 50]);
    mEnrolleesData.IsCardViewInitialized = false;
    $('#uMasterMenuPanel').show();
    uEnrolleesCardView_Init();
    mStateManagerEnrolleesLayout_Init(null, mStateManager.Hash());
}
// LEAVE
function mStateManagerEnrollees_Leave(aPrevious, aCurrent) {
    "use strict";
    mCache.unbind('EnrolleeLastContactupdated', EnrolleeLastContact_Updated);
    mCache.unbind('CurrentDeviceAssignmentsupdated', enrolleesDataItem_Updated);
    mCache.unbind('EnrolleeEventSummaryupdated', enrolleesDataItem_Updated);
    mCache.unbind('Enrolleesupdated', enrolleesDataItem_Updated);
    mCache.unbind('EnrolleeLastContactupdated', enrolleesDataItem_Updated);
    mCache.unbind('DeviceClusterEnrolleeupdated', enrolleesDataItem_Updated);
    var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');
    if (lAgentsStopCheck) {
        var lTransactionDate = new Date(moment());
        logUserTransaction(mEnrolleesData.OffenderCurrentId, 5, gUserDetails.UserId, lTransactionDate, lTransactionDate, lTransactionDate);
    }
    mEnrolleesControls.veritracksChartMiniMap = null;
    if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
        mEnrolleesControls.CardView.dispose();
        mEnrolleesControls.CardView = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.CardViewTimer)) {
        mEnrolleesControls.CardViewTimer = null;
    }
    if (aPrevious.Settings[0] === 'Offenders') {
        if (!isNullOrUndefined(mEnrolleesControls.OffenderProfileValidator)) {
            mEnrolleesControls.OffenderProfileValidator.dispose();
            mEnrolleesControls.OffenderProfileValidator = null;
        }
    } else {
        if (!isNullOrUndefined(mEnrolleesControls.VictimProfileValidator)) {
            mEnrolleesControls.VictimProfileValidator.dispose();
            mEnrolleesControls.VictimProfileValidator = null;
        }
    }
    delete mEnrolleesData.EnrolleeAlternateContact;
    delete mEnrolleesData.EnrolleeAlternateContacts;
    deleteViewState('SpatialMatchesEnrollee');
    mStateManagerEnrolleesLayout_Leave(aPrevious, aCurrent);
}



// STATE ENROLLEES LAYOUT CALLS
// Enrollee Layout could be: Offenders / Victims
/**
 * This Function is executed when selecting a new Layout in the Enrollees Tab
 * e.g.  Enrollees > Victims
 * @param  {} aPrevious
 * @param  {} aCurrent
 * e.g.
 * ChangeHashSettings(0, 'Victims');
 * ChangeHashSettings(0, 'Offenders'); // 0 means Layout ,1 means Primary, 2 Secondary, 3 Tertiary
 */
function mStateManagerEnrolleesLayout_Init(aPrevious, aCurrent) {
    "use strict";
    var state = mStateManager.getSystemState();
    var lVictimTabEnabled = veritracks.system.clientSetting('VictimMonitoringEnabled');
    if (applyUserPermissionsNavigation(gPageClassManager.Enrollees,state.Layout)) {
        //UI 
        $('.LayoutTab.Selected').removeClass('Selected');
        $('#u' + aCurrent.Tab + 'LayoutTab' + state.Layout).addClass('Selected');
        var aIdClass ='#uEnrolleesLayoutTabVictims';
        lVictimTabEnabled ?$(aIdClass).show():$(aIdClass).hide();
        //DATA
        if (!isNullOrUndefined(aCurrent.Settings[3]) && aCurrent.Settings[3] !== 'null') {
            mEnrolleesData.TargetId = parseInt(aCurrent.Settings[3]);
            //mStateManager.ChangeSettings(3, null);
        }
        // EVENTS
        if (mStateManager.IsSystemState('Layout','Offenders')) {
            uOffendersCardViewFilter_Init();
            uOffendersCardViewPaginator_Init();
        }
        if (mStateManager.IsSystemState('Layout','Victims')) {
            //Trigger automatic state
            //mStateManagerEnrolleesVictimsLayout_Init();
            if(!isNullOrUndefined(window['mStateManager'+state.Tab+state.Layout+'Layout_Init'])){
                window['mStateManager'+state.Tab+state.Layout+'Layout_Init']();
            }
        }
        //Trigger after all is done
        mStateManagerEnrolleesLayout_OnComplete();
    }
}

function mStateManagerEnrolleesLayout_OnComplete() {
    "use strict";
    var lNeedsClusters = false,
        lFeaturePreview = veritracks.system.clientSetting('veritracksfeaturepreview'),
        lBuilder;
    function onSuccess() {
        mCache.unbind('DeviceClusterEnrolleeupdated', onSuccess);
        enrolleesDataListConverter();
        mStateManagerEnrolleesPrimary_Init(null, mStateManager.Hash());
        if (!isNullOrUndefined(mEnrolleesControls.CardViewOffenderFilter)) {
            mEnrolleesControls.CardViewOffenderFilter.filter();
        }
        if (getTimelineLoadPreference() == 1){
            if (enrolleesSmallChart_Init()) {
                enrolleeCycleCaseLoadNext(0, true); // first one
                $('#uLoadAllDayTimelineMap').hide();
            }
        }
        uEnrolleesCardViewSortOnViewState();
    }
    applyUserPermissions([1, 10, 13, 14, 15, 16, 17, 18, 19, 20, 32, 46, 47, 48, 49]);
    if (lFeaturePreview) {
        applyUserPermissions([61]);
    } else {
        // always remove if no client property set.
        $('.pFeaturePreview').remove();
        $('#HeatMapCharButton').hide();
    }
    var aHeatPerm = gUserPermissions[61];
    if (!isNullOrUndefined(aHeatPerm) && (aHeatPerm.Value == 1 || aHeatPerm.Value == 2)) {
        $('#HeatMapCharButton').show();
    } else {
        $('#HeatMapCharButton').hide();
    }
    if (mStateManager.Settings()[0] === 'Offenders') {
        $('#uEnrolleesSecondaryMenuAddresses').show();
        $('#uEnrolleesSecondaryMenuSchedules').show();
        if (gEnrolleeIds.length > 0) {
            lNeedsClusters = true;
            lBuilder = new SumoPredicateBuilder();
           // lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EnrolleeId', gEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            mCache.bind('DeviceClusterEnrolleeupdated', onSuccess);
            mCache.AddUpdatableItem('DeviceClusterEnrollee',
                                        gObjectList.DeviceClusterEnrollee.AssemblyQualifiedName,
                                        lBuilder.RootExpression,
                                        60,
                                        null,
                                        null,
                                        true,
                                        null);
        }
        //show sobertrack if sobertrack device
    }
    if (!lNeedsClusters) {
        $('#uEnrolleesSecondaryMenuAddresses').hide();
        $('#uEnrolleesSecondaryMenuSchedules').hide();
        if (mStateManager.Settings()[2] === 'Addresses' || mStateManager.Settings()[2] === 'Schedules') {
            ChangeHashSettings(2, 'Events');
        }
        mStateManagerEnrolleesPrimary_Init(null, mStateManager.Hash());
    }

}
function mStateManagerEnrolleesLayout_Leave(aPrevious, aCurrent) {
    "use strict";
    if (aPrevious.Settings[0] === 'Offenders') {
        if (!isNullOrUndefined(mEnrolleesControls.CardViewOffenderFilter)) {
            mEnrolleesControls.CardViewOffenderFilter.dispose();
            mEnrolleesControls.CardViewOffenderFilter = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.CardViewOffenderPaginator)) {
            mEnrolleesControls.CardViewOffenderPaginator.dispose();
            mEnrolleesControls.CardViewOffenderPaginator = null;
        }
    } else {
        if (!isNullOrUndefined(mEnrolleesControls.CardViewVictimFilter)) {
            mEnrolleesControls.CardViewVictimFilter.dispose();
            mEnrolleesControls.CardViewVictimFilter = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.CardViewVictimPaginator)) {
            mEnrolleesControls.CardViewVictimPaginator.dispose();
            mEnrolleesControls.CardViewVictimPaginator = null;
        }
    }
    $('#uOffendersCardViewFilterOrganizationId').unbind('change', uEnrolleesFilterOrganization_OnChange);
    mStateManagerEnrolleesPrimary_Leave(aPrevious, aCurrent);
}

/**
 * This function is automatically called when the state
 * detects a change in the Enrollees Primary Level 
 * e.g. Profile / Map 
 * @param  {} aPrevious
 * @param  {} aCurrent
 * @example 
 * mStateManager.getSystemState()
 */
function mStateManagerEnrolleesPrimary_Init(aPrevious, aCurrent) {
    "use strict";
    var lFilename = 'Enrollees.' + aCurrent.Settings[0] + '.' + aCurrent.Settings[1] + '.Layout.htm',
        lPageClass = gPageClassManager.EnrolleesOffenderPrimary;
    //if (aCurrent.Settings[0] === 'Victims') {
    //    lPageClass = gPageClassManager.EnrolleesVictimPrimary;
    //   // $('#uEnrolleesMainMenuPanel').load('Interface/Enrollees.Victims.PrimaryTab.Options.htm', setPrimaryTabs);

    //} else {
    //    $('#uEnrolleesMainMenuPanel').load('Interface/Enrollees.Offenders.PrimaryTab.Options.htm', setPrimaryTabs);
    //}
    if (aCurrent.Settings[0] === 'Victims') {
        lPageClass = gPageClassManager.EnrolleesVictimPrimary;
        $('.pEnrolleesOffenderMap').hide();
        $('.pEnrolleesOffenderFRP').hide();
        $('.pEnrolleesOffenderProfile').hide();
        $('.pEnrolleesVictimProfile').show();
        $('.pEnrolleesVictimMap').show();
        $('#uEnrolleesVictimNotifications').show();
        $('.pEnrolleesVictimNotes').show();
        $('.pEnrolleesVictimDeviceAssignments').show();
        $('.pEnrolleesOffenderNotes').hide();
        $('.pEnrolleesOffenderDeviceAssignments').hide();
        $('.pEnrolleesOffenderSoberTrackReview').hide();
    } else {
        $('.pEnrolleesOffenderMap').show();
        $('.pEnrolleesOffenderProfile').show();
        $('.pEnrolleesVictimProfile').hide();
        $('.pEnrolleesVictimMap').hide();
        $('#uEnrolleesVictimNotifications').hide();
        $('.pEnrolleesVictimNotes').hide();
        $('.pEnrolleesVictimDeviceAssignments').hide();
        $('.pEnrolleesOffenderNotes').show();
        $('.pEnrolleesOffenderDeviceAssignments').show();
        $('.pEnrolleesOffenderSoberTrackReview').show();
    }

    //function setPrimaryTabs() {
        if (applyUserPermissionsNavigation(lPageClass, aCurrent.Settings[1])) {
            $('#uEnrolleesMainMenuPanel .Selected').removeClass('Selected');
            $('#uEnrolleesMainMenuPanel .' + aCurrent.Settings[1] + 'Tab').addClass('Selected');
            populateElement('uEnrolleesMainContentPanel', lFilename, mStateManagerEnrolleesPrimary_OnComplete);
            if (aCurrent.Settings[1] === 'Map') {
                //veritracks.enrollees.mapping.tagDataUpdated();
                //mCache.bind('Tagupdated', veritracks.enrollees.mapping.tagDataUpdated);
                mEnrolleesData.OffenderMapRequestCount = 0;
                if (isNullOrUndefined(mEnrolleesControls.PrimaryEnrolleeTimer))
                    mEnrolleesControls.PrimaryEnrolleeTimer = new TimerManager(500);
                if (isNullOrUndefined(mEnrolleesControls.SecondaryEnrolleeTimer))
                    mEnrolleesControls.SecondaryEnrolleeTimer = new TimerManager(500);

                $('#uPrimaryMapCollapsePanel').show('fast');
                $('#uEnrolleesSecondaryContentHolder').hide('fast', resetContentHolders);
                //enrolleesSmallChartMap_Init(true);
            } else if (aCurrent.Settings[1] === "SoberTrackReview"){
                $('#uPrimaryMapCollapsePanel').hide('fast');
                $('#uEnrolleesSecondaryContentHolder').hide('fast', resetContentHolders);
            }else {
                if ($('#uEnrolleesListCell').hasClass('ChartingLimit') && getTimelineLoadPreference() == 0) {
                    removeBigChart(false);
                    mEnrolleesControls.veritracksChartMiniMap = null;
                }
                veritracks.mapping.setMapPanelDisplay(this, 'uEnrolleesListCell', true, enrolleesMapPanel_OnClick);
                $('#uPrimaryMapCollapsePanel').hide('fast');
                if (mEnrolleesData.IsSecondaryVisible) {
                    $('#uEnrolleesSecondaryContentHolder').show('fast', resetContentHolders);
                }

            }
        }
   // }

}
function mStateManagerEnrolleesPrimary_OnComplete() {
    "use strict";
    var lPreferences,
        lPreference,
        lVisitPreferences,
        lVisitPreference;
    applyUserPermissions([1, 2, 10, 13, 14, 15, 16, 17, 18, 19, 20, 32, 37, 38, 46, 47, 48, 49]);

    if (mStateManager.Settings()[1] === 'Map') {
        lPreferences = getUserPreferences(4);
        lPreference = lPreferences['MapTimeSpan'];
        if (!isNullOrUndefined(lPreference)) {
            $('#uEnrolleeMapTimeFilter').val(lPreference.Value);
        }

        mEnrolleesControls.NotificationPanel = new SumoActivityNotification('uMapNotificationPanel', 'uEnrolleesMapPrint', 50, { 'allowClose': true });
        mEnrolleesControls.NotificationPanel.render();
        // Lock
        veritracks.enrollees.mapping.getLockState();
        if (mStateManager.Settings()[0] === 'Offenders') {
            uOffenderMap_Init();
        } else {
            Victim.uVictimMap_Init();
        }
        uOffenderMapMaxSearch_Init();
        offendersMapDropdowns_Init();
        uOffendersMapSettingsListView_Init();
        //populateElement('uMapLegendContent', 'Map.Legend.htm', null);
        //populateElement('uLocateMapHolder', 'Map.Locate.htm', null);
        //populateElement('uMapDetailsContent', 'Enrollees.Offenders.Map.Details.htm', null);
        mEnrolleesControls.EnrolleeMapLocate = new sumo.maps.Locate('uMapLocate', 'uLocateMapHolder', mEnrolleesControls.EnrolleesMap, {});
        mEnrolleesControls.EnrolleeMapLocate.bind('complete', enrolleesPlaces_OnComplete);
        $('#uAssignTagSelect').autocomplete({
            'source': mAvailableTags,
            'minLength': 0,
            'select': function (event, Ui) {
                mEnrolleesData.OffenderVisitTagId = Ui.item.id;
                $(this).val(Ui.item.label);
            }
        }).focus(function () {
            $(this).autocomplete('search');
        });
    } else if (mStateManager.Settings[1] === 'SobertrackReview') {
        $('#uEnrolleesSecondaryContentHolder').hide('fast');
        // mStateManagerEnrolleesTertiary_Init(null, mStateManager.Hash());
        // uEnrolleesSoberTrackReviewListView_Init();

    }else {
        populateDateView('#uOffenderProfileSupervisionBeginDateEdit', offenderDatePicker_OnChange);
        populateDateView('#uOffenderProfileSupervisionEndDateEdit', offenderDatePicker_OnChange);
        populateDateView('#uOffenderProfileBirthdateEdit', offenderDatePicker_OnChange);
        populateDateView('#uOffenderProfileReferralDateEdit', offenderDatePicker_OnChange);
        uInitializeThreads();
        mStateManagerEnrolleesSecondary_Init(null, mStateManager.Hash());
    }
    if (mEnrolleesData.IsCardViewInitialized) {
        var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
        if (mStateManager.Settings()[0] === 'Victims') {
            lEnrolleeId = mEnrolleesData.VictimCurrentId;
        }
        if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
            if (mEnrolleesControls.CardView.selected() == null) {
                //TODO: Improve selection
                mEnrolleesControls.CardView.selectedIndex(0);
            }
            uEnrolleesCardView_OnSelectChange(null, mEnrolleesControls.CardView.selected(), null);
        }
    }
   
    veritracks.system.applyControlState('Enrollees', mEnrolleesControls.OffenderCardView);
    $('#uOffenderProfilePanel').show();
}

function mStateManagerEnrolleesPrimary_Leave(aPrevious, aCurrent) {
    "use strict";
    if (aPrevious.Settings[1] === 'Map') {
        if (aPrevious.Settings[0] === 'Offenders') 
        {
            if (mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId]) {
                mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId].finish()
            }
            $('#uAssignTagSelect').autocomplete('destroy');
            if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
                mEnrolleesControls.EnrolleesMap.dispose();
                mEnrolleesControls.EnrolleesMap = null;
            }
           
            if (!isNullOrUndefined(mEnrolleesControls.EnrolleeMapLocate)) {
                mEnrolleesControls.EnrolleeMapLocate.unbind('complete', enrolleesPlaces_OnComplete);
                mEnrolleesControls.EnrolleeMapLocate.dispose();
                mEnrolleesControls.EnrolleeMapLocate = null;
            }
            if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView)) {
                mEnrolleesControls.OffenderTrackpointDetailCardView.dispose();
                mEnrolleesControls.OffenderTrackpointDetailCardView = null;
            }
            if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardViewFilter)) {
                mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.dispose();
                mEnrolleesControls.OffenderTrackpointDetailCardViewFilter = null;
            }
            mEnrolleesControls.PrimaryEnrolleeTimer = null;
            mEnrolleesControls.SecondaryEnrolleeTimer = null;
            veritracks.enrollees.mapping.data = {
                'PrimaryCardList': [],
                'PrimaryRequest': -999,
                'SecondaryCardList': [],
                'SecondaryRequest': -999,
                'VisitCardList': [],
                'TagCardList': null,
                'EnrolleesLoading': 0,
                'IsLocked': false,
                'DoGeocode': false,
                'DoDistanceCalculation': false,
                'DoAddHomeAddress': false,
                'ExportData': null,
                'DisplayVisitCount': false,
                'DoFitBounds': true,
                'PreviousZoom': 0,
                'CurrentCardType': 0,
                'LookAheadCardList': [],
                'TimeChangeTimerId': null,
                'RequestIds': {
                    'PrimaryTripVisit': null,
                    'SecondaryTripVisit': null
                }
            };
        } else {
            if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
                mEnrolleesControls.EnrolleesMap.dispose();
                mEnrolleesControls.EnrolleesMap = null;
            }
            if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMapLocate)) {
                mEnrolleesControls.EnrolleesMapLocate.unbind('complete', enrolleesPlaces_OnComplete);
                mEnrolleesControls.EnrolleesMapLocate.dispose();
                mEnrolleesControls.EnrolleesMapLocate = null;
            }
            if (!isNullOrUndefined(mEnrolleesControls.VictimTrackpointDetailCardView)) {
                mEnrolleesControls.VictimTrackpointDetailCardView.dispose();
                mEnrolleesControls.VictimTrackpointDetailCardView = null;
            }
            if (!isNullOrUndefined(mEnrolleesControls.VictimTrackpointDetailCardViewFilter)) {
                mEnrolleesControls.VictimTrackpointDetailCardViewFilter.dispose();
                mEnrolleesControls.VictimTrackpointDetailCardViewFilter = null;
            }
            mEnrolleesControls.PrimaryEnrolleeTimer = null;
            mEnrolleesControls.SecondaryEnrolleeTimer = null;
            veritracks.enrollees.mapping.data = {
                'PrimaryCardList': [],
                'PrimaryRequest': -999,
                'SecondaryCardList': [],
                'SecondaryRequest': -999,
                'VisitCardList': [],
                'TagCardList': null,
                'EnrolleesLoading': 0,
                'IsLocked': false,
                'DoGeocode': false,
                'DoDistanceCalculation': false,
                'DoAddHomeAddress': false,
                'ExportData': null,
                'DisplayVisitCount': false,
                'DoFitBounds': true,
                'PreviousZoom': 0,
                'CurrentCardType': 0,
                'LookAheadCardList': [],
                'TimeChangeTimerId': null,
                'RequestIds': {
                    'PrimaryTripVisit': null,
                    'SecondaryTripVisit': null
                }
            };
        }
        if (!isNullOrUndefined(mEnrolleesControls.SchedulesBluPlusConfigurationListView)) {
            mEnrolleesControls.SchedulesBluPlusConfigurationListView.dispose();
            mEnrolleesControls.SchedulesBluPlusConfigurationListView = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.MapSettingsListView)) {
            mEnrolleesControls.MapSettingsListView.dispose();
            mEnrolleesControls.MapSettingsListView = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.PlaybackControl)) {
            mEnrolleesControls.PlaybackControl.dispose();
            mEnrolleesControls.PlaybackControl = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.LegendDropdown)) {
            mEnrolleesControls.LegendDropdown.dispose();
            mEnrolleesControls.LegendDropdown = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.DetailsDropdown)) {
            mEnrolleesControls.DetailsDropdown.dispose();
            mEnrolleesControls.DetailsDropdown = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.LocateDropdown)) {
            mEnrolleesControls.LocateDropdown.dispose();
            mEnrolleesControls.LocateDropdown = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.NotesDropdown)) {
            mEnrolleesControls.NotesDropdown.dispose();
            mEnrolleesControls.NotesDropdown = null;
        }
        if (!isNullOrUndefined(mEnrolleesControls.SettingsDropdown)) {
            mEnrolleesControls.SettingsDropdown.dispose();
            mEnrolleesControls.SettingsDropdown = null;
        }
        //mCache.unbind('Tagupdated', veritracks.enrollees.mapping.tagDataUpdated);
    } else if (aPrevious.Settings[1] === 'SoberTrackReview'){
        if(!isNullOrUndefined(mEnrolleesControls.SoberTrackTestsListView)){
            mEnrolleesControls.SoberTrackTestsListView.dispose();
            mEnrolleesControls.SoberTrackTestsListView = null;
        }
    } else {
        uExpandMapButtonButton_OnClick(this);
    }
   
    if (aCurrent.Settings[0] === 'Victims') {
        removeBigChart();
    }
    mStateManagerEnrolleesSecondary_Leave(aPrevious, aCurrent);
}




// STATE SECONDARY CALLS 
/**
 * This function will be called when State Manager Detects a change in Tab
 * @param  {} aPrevious
 * @param  {} aCurrent
 */
function mStateManagerEnrolleesSecondary_Init(aPrevious, aCurrent) {
    "use strict";
    var lFilename = 'Enrollees.' + mStateManager.Settings()[0] + '.' + mStateManager.Settings()[1] + '.' + mStateManager.Settings()[2] + '.Layout.htm',
        lPageClass = gPageClassManager.EnrolleesOffenderSecondary;
    if (aCurrent.Settings[0] === 'Victims') {
        uEnrolleeEventsNotesManager_Init();
        lPageClass = gPageClassManager.EnrolleesVictimSecondary;
    }
    //Permission??? || applyUserPermissionsNavigation(lPageClass, aCurrent.Settings[2], false)
    if (aCurrent.Settings[1] === 'Map' || gUserDetails.Role !== 2) {
        $('#uEnrolleesSecondaryMenuPanel .Selected').removeClass('Selected');
        $('#uEnrolleesSecondaryMenuPanel .' + aCurrent.Settings[2] + 'Tab').addClass('Selected');
        if (aCurrent.Settings[1] === 'Profile') {
            populateElement('uEnrolleesSecondaryContentPanel', lFilename, mStateManagerEnrolleesSecondary_OnComplete); // artf79418 removed populate element for mapping.
            mEnrolleesData.IsSecondaryVisible = true;
            $('#uEnrolleesSecondaryContentHolder').show('fast', resetContentHolders);
            $('#uEnrolleesSecondaryMenuPanel').show();
            $('#uEnrolleesSecondaryContentPanel').show();
            //EnrolleePage_uRefreshButton_OnClick();
            loadPhotoTypes();
            $('#uLoadAllDayTimelineMap').hide();
            if ($('#uEnrolleesListCell').hasClass('ChartingLimit') && getTimelineLoadPreference() == 0) {
                removeBigChart(false);
                mEnrolleesControls.veritracksChartMiniMap = null;
            }

        } else {
            mStateManagerEnrolleesSecondary_OnComplete(); // artf79418 removed populate element for mapping.
                    // mEnrolleesControls.SoberTrackTestsListView.setDataSource(GetSoberTrackDetailFromEnrolleeId(mEnrolleesControls.CardView.selectedDataItem().Enrollee.Id));

            $('#uLoadAllDayTimelineMap').show();
            var lView = getViewState('AnalysisView');

            if (lView) {
                mEnrolleesData.AnalysisEnrollee = 1;
                $('#uEnrolleeSpatialBackButton').show();
            }
        }
    }
    if(aCurrent.Settings[1]==='SoberTrackReview' ){
        mEnrolleesData.IsSecondaryVisible = false;
        $('#uEnrolleesSecondaryContentHolder').hide('fast', resetContentHolders);
        $('#uEnrolleesSecondaryMenuPanel').hide();
        $('#uEnrolleesSecondaryContentPanel').hide();
        $('#uEnrolleesMainContentPanel .ButtonBar.ContentOverhead').hide();
        window['mStateManagerEnrolleesPrimary' + mStateManager.Settings()[1] + '_Init']();
        mStateManagerEnrolleesSecondary_OnComplete();
    }
    if (aCurrent.Settings[1] === 'Profile' && gUserDetails.Role == 2) {
        mEnrolleesData.IsSecondaryVisible = false;
        $('#uEnrolleesSecondaryContentHolder').hide('fast', resetContentHolders);
        $('#uEnrolleesSecondaryMenuPanel').hide();
        $('#uEnrolleesSecondaryContentPanel').hide();
        $('#uEnrolleesMainContentPanel .ButtonBar.ContentOverhead').hide();
    }
    if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
        mEnrolleesControls.CardView.selected(mEnrolleesData.OffenderCurrentId);
        if (mEnrolleesData.OffenderCurrentId == -1) {
            if (!$("#uHomeToolCommandButton").hasClass("regionalOri")) {
                $("#uHomeToolCommandButton").addClass("regionalOri");
                $("#uMapCommandCell").css("width", "115px");
            }
        }
    }
    if (gUserDetails.RegionalOri) {
        if (getViewState("isRegionalLoaded") == null || !getViewState("isRegionalLoaded")) {
            $("#uEnrolleesSecondaryContentHolder").addClass("regionalOri")
            $("#uEventsTab").addClass("regionalOri");
            $("#uZonesTab").addClass("regionalOri");
        }
        var selectedEnrolleId = mEnrolleesControls.CardView.selected();
        var enrollee = getDataItem(selectedEnrolleId, "Enrollees");
        if (enrollee) {
            if (getViewState("RegionalLoadedId") != null && getViewState("RegionalLoadedId").Value == enrollee.OrganizationId) {
                addUnloadButton();
            } else {
                addLoadOriButton();
            }
        }
    } else {
        if ($("#uEventsTab").hasClass("regionalOri")) {
            $("#uEventsTab").removeClass("regionalOri");
        }
        if ($("#uZonesTab").hasClass("regionalOri")) {
            $("#uZonesTab").removeClass("regionalOri");
        }
    }
}

function mStateManagerEnrolleesSecondary_Leave(aPrevious, aCurrent) {
    "use strict";

    if (aPrevious.Settings[1] == 'Map' && aCurrent.Settings[1] == 'Profile' && (aPrevious.Settings[0] == aCurrent.Settings[0])) {
        veritracks.enrollees.mapping.setTravelToProfileLock();
    }
    else if (aPrevious.Tab != aCurrent.Tab) {
        mEnrolleesData.secondLockDate = null;
        mEnrolleesData.secondLockOnEnrolleeId = null;
        mEnrolleesData.IsExpandedAllVisits = false;
        veritracks.enrollees.mapping.data.PrimaryCardList = [];
        mEnrolleesData.OffenderPastData = [];
    }

    if (aPrevious.Settings[1] === 'Profile') {
        switch (aPrevious.Settings[2]) {
            case 'Events':
                //uEnrolleesCardView_OnUpdate();
                if (!isNullOrUndefined(mEnrolleesControls.EventsListView)) {
                    mEnrolleesControls.EventsListView.dispose();
                    mEnrolleesControls.EventsListView = null;
                }
                if (aCurrent.Settings[2] !== 'Events' || aCurrent.Settings[1] === 'Map') {
                    if (!isNullOrUndefined(mEnrolleesControls.EventsListViewFilter)) {
                        mEnrolleesControls.EventsListViewFilter.dispose();
                        mEnrolleesControls.EventsListViewFilter = null;
                    }
                }
                mEnrolleesControls.EventsNotesManager = null;
                break;
            case 'Notes':
                mEnrolleesControls.NotesManager = null;
                break;
            case 'ContactHistory':
                if (!isNullOrUndefined(mEnrolleesControls.ContactHistoryListView)) {
                    mEnrolleesControls.ContactHistoryListView.dispose();
                    mEnrolleesControls.ContactHistoryListView = null;
                }
                break;
            case 'Assignments':
                if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
                    mEnrolleesControls.TrackingDeviceCardView.dispose();
                    mEnrolleesControls.TrackingDeviceCardView = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsListView)) {
                    mEnrolleesControls.DeviceAssignmentsListView.dispose();
                    mEnrolleesControls.DeviceAssignmentsListView = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsContactList)) {
                    mEnrolleesControls.DeviceAssignmentsContactList.dispose();
                    mEnrolleesControls.DeviceAssignmentsContactList = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsMap)) {
                    mEnrolleesControls.DeviceAssignmentsMap.dispose();
                    mEnrolleesControls.DeviceAssignmentsMap = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.StationCardView)) {
                    mEnrolleesControls.StationCardView.dispose();
                    mEnrolleesControls.StationCardView = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsValidator)) {
                    mEnrolleesControls.DeviceAssignmentsValidator.dispose();
                }
                mEnrolleesData.OffenderEidReservation = null;
                break;
            case 'Schedules':
                if (!isNullOrUndefined(mEnrolleesControls.SchedulesListView)) {
                    mEnrolleesControls.SchedulesListView.dispose();
                    mEnrolleesControls.SchedulesListView = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.SchedulesView)) {
                    mEnrolleesControls.SchedulesView.dispose();
                    mEnrolleesControls.SchedulesView = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.SchedulesTargetCardView)) {
                    mEnrolleesControls.SchedulesTargetCardView.dispose();
                    mEnrolleesControls.SchedulesTargetCardView = null;
                }
                mCache.unbind('Zonesupdated', enrolleesScheduleZonesDataListConverter);
                setViewState('ZoneScheduleId', null);
                setViewState('ZoneScheduleEnrolleeId', null);
                mEnrolleesData.TargetZoneId = -1;
                break;
            case 'Addresses':
                if (!isNullOrUndefined(mEnrolleesControls.AddressesMap)) {
                    mEnrolleesControls.AddressesMap.dispose();
                    mEnrolleesControls.AddressesMap = null;
                }
                if (!isNullOrUndefined(mEnrolleesControls.AddressesValidator)) {
                    mEnrolleesControls.AddressesValidator.dispose();
                    mEnrolleesControls.AddressesValidator = null;
                }
                break;
        }
    }
}

function mStateManagerEnrolleesSecondary_OnComplete() {
    "use strict";
    applyUserPermissions([1, 14, 15, 16, 17, 18, 19, 20, 32, 33, 34, 37, 47, 48, 49, 71]);
    $(window).resize();
    var state = mStateManager.getSystemState();
    if (state.Primary === 'Profile') {
        window['mStateManagerEnrolleesSecondary' + state.Secondary + '_Init']();
    }
    mStateManagerEnrolleesTertiary_Init(null, mStateManager.Hash());
    veritracks.system.applyControlState('Enrollees', mEnrolleesControls.CardView);
    if ($("#ie").hasClass("ie8")) {
        resetContentHoldersEnrollees();
    }
}
function mStateManagerEnrolleesSecondaryEvents_Init() {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;

    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
    uEnrolleesEventsListView_Init();
    uOffendersEventsPaginator_Init();
    uEnrolleesEventsListViewFilter_Init();
   // EnrolleeProfileEvents_Init(lEnrolleeId);
    uEnrolleeEventsNotesManager_Init();
    $('#uEnrolleesEventNewNoteButton').hide();
}


function mStateManagerEnrolleesSecondaryFrp_Init() {
    "use strict";
    EnrolleeProfileFrp_Init();
}
function mStateManagerEnrolleesSecondaryNotes_Init() {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
    EnrolleeProfileNotes_Init(lEnrolleeId);
}
function mStateManagerEnrolleesSecondaryEMA_Init() {
    "use strict";
    var selfReportNotification = 0,//get notfication
        scheduleRequestNotification = 0,
        messagingNotification = 0;
        if(AgentHelper.getPermissionValueById(61)< 1){
            $("#uEnrolleesMobileAppVideoCall").remove()
        }
    if (mEnrolleesData.EMASelfReportRequest) {
        for (var i = 0; i < mEnrolleesData.EMASelfReportRequest.length; i++) {
            if (mEnrolleesData.EMASelfReportRequest[i].AgentDecision === "1") {
                selfReportNotification++
            }
        }
        for (var i = 0; i < mEnrolleesData.EMAScheduleRequest.length; i++) {
            if (mEnrolleesData.EMAScheduleRequest[i].AgentDecision === "1") {
                scheduleRequestNotification++
            }
        }

        if (selfReportNotification > 0) {
            $('#uEnrolleesMobileAppSelfReportingNotification').text(selfReportNotification);
            $('#uEnrolleesMobileAppSelfReportingNotification').addClass('NotificationNumber');
        } else {
            $('#uEnrolleesMobileAppSelfReportingNotification').text("");
            $('#uEnrolleesMobileAppSelfReportingNotification').removeClass('NotificationNumber');
        }
        if (scheduleRequestNotification > 0) {
            $('#uEnrolleesMobileAppScheduleRequestNotification').text(scheduleRequestNotification);
            $('#uEnrolleesMobileAppScheduleRequestNotification').addClass('NotificationNumber');
        } else {
            $('#uEnrolleesMobileAppScheduleRequestNotification').text("");
            $('#uEnrolleesMobileAppScheduleRequestNotification').removeClass('NotificationNumber');
        }
    }
}
function mStateManagerEnrolleesSecondaryAddresses_Init() {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
    EnrolleeProfileAddresses_Init(lEnrolleeId)
}

// ASSIGNMENTS PROCCESSING
function mStateManagerEnrolleesSecondaryAssignments_Init() {
    "use strict";
    $('#uEnrolleesRemoveAssignment').hide();
    $('#uEnrolleesRemoveVictimAssignment').hide();
    $('#uAudibleToneWhenLowBatteryHolder').hide();
    var isFlagEnabled =veritracks.system.clientSetting('enableaudibleinlowbattery');
    if(!isNullOrUndefined(isFlagEnabled)){
        $('#uAudibleToneWhenLowBatteryHolder')[isFlagEnabled?'show':'hide']();
    }
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    uEnrolleesAssignmentsListView_Init();
    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
   EnrolleeProfileAssignments_Init(lEnrolleeId);
}
function mStateManagerEnrolleesSecondarySchedules_Init() {
	"use strict";
	$('#uAddScheduleButton').hide();
	$('#uEditScheduleButton').hide();
	$('#uDeleteScheduleButton').hide();
	$('#uSelectAllScheduleButton').hide();
	$('#uUnSelectAllScheduleButton').hide();
	$('#uEnrolleeViewCarveOutScheduleButton').hide();
	$('#uEnrolleeViewScheduleButton').hide();

    var lUser = getDataItem(gUserDetails.UserId, 'Users');
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
    if (displayOldScheduleUILoggedInOri(lEnrolleeId)) {
        $('#uEnrolleeScheduleActionButtonBar').show();
    }

    uEnrolleesSchedulesListView_Init();
	EnrolleeProfileSchedules_Init(lEnrolleeId);

    enrolleeAddress_Init(lEnrolleeId, enrolleesScheduleAddressesDataListConverter);
}

// CONTACTHISTORY PROCESSING
function mStateManagerEnrolleesSecondaryContactHistory_Init() {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    uEnrolleesContactHistoryListView_Init();
    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
    EnrolleeProfileContactHistory_Init(lEnrolleeId);
}

// STATE MANAGER TIERTIARY (3rd level)
// e.g. Events, CaseNotes, Device Assigments, etc 
function mStateManagerEnrolleesTertiary_Init(aPrevious, aCurrent) {
    "use strict";
    if (!isNullOrUndefined(aCurrent.Settings[3]) && aCurrent.Settings[3] !== 'null') {
        mEnrolleesData.TargetId = parseInt(aCurrent.Settings[3]);
        mStateManager.ChangeSettings(3, null);
        if (aCurrent.Settings[0] === 'Offenders') {
            mEnrolleesControls.CardViewOffenderFilter.filter();
        } else {
            mEnrolleesControls.CardViewVictimFilter.filter();
        }
    }
    // localize here
    veritracks.localization.localizeTitle();
}
